// extracted by mini-css-extract-plugin
export default {"logoContainer":"index_logoContainer__2cDvH","logo":"index_logo__mZLAT"};